import { Link } from "react-router-dom";

import { useEffect, useState, useCallback } from "react";

import { modules } from "../data/modules";
import { useAuth } from "../contexts/AuthContext";

import { loadAllProgress }
    from "../services/progress";

export default function Progress() {
    const { user } = useAuth();
    const [completedIds, setCompletedIds] =
        useState([]);

    const loadProgress = useCallback(async () => {

        if (!user) return;

        const progress =
            await loadAllProgress();

        setCompletedIds(
            progress
                .filter(activity => activity.completed)
                .map(activity => activity.id)
        );

    }, [user]);




    useEffect(() => {

        loadProgress();

        window.addEventListener(
            "progressUpdated",
            loadProgress
        );

        return () =>
            window.removeEventListener(
                "progressUpdated",
                loadProgress
            );

    }, [loadProgress]);

    return (

        <div
            className="page"
            style={{
                maxWidth: "1000px",
                margin: "0 auto",
                padding: "20px"
            }}
        >
            <Link to="/" className="safe-top-link">
    ← Home
</Link>
            <h1>My Progress</h1>
            <p>

                You have completed{" "}

                <strong>

                    {completedIds.length}

                </strong>

                {" of "}

                <strong>

                    {modules.reduce(

                        (total, module) =>

                            total +
                            module.activities.length,

                        0

                    )}

                </strong>

                {" activities."}

            </p>
            {modules.map(module => {

                const done =
                    module.activities.filter(

                        activity =>
                            completedIds.includes(
                                activity.id
                            )

                    ).length;

                return (

                    <div
                        key={module.id}
                        style={{
                            marginBottom: "2rem",
                            padding: "20px",
                            borderRadius: "12px",
                            background: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,.08)"
                        }}
                    >


                        <h2
                            style={{
                                marginTop: 0
                            }}
                        >
                            {module.title}
                        </h2>

                        <progress
                            value={done}
                            max={module.activities.length}
                            style={{
                                width: "100%",
                                height: "18px",
                                marginBottom: "0.5rem",
                            }}
                        />

                        <p>
                            {done} of {module.activities.length} completed
                        </p>


                        <ul
                            style={{
                                listStyle: "none",
                                padding: 0,
                                display: "grid",
                                gridTemplateColumns:
                                    "repeat(auto-fit, minmax(260px, 1fr))",
                                gap: "8px 24px"
                            }}
                        >
                            {module.activities.map(activity => (

                                <li
                                    key={activity.id}
                                    style={{
                                        marginBottom: "0.4rem",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        background:
                                            completedIds.includes(activity.id)
                                                ? "#eef8ee"
                                                : "#f8f8f8"
                                    }}
                                >
                                    <Link
                                        to={`/activity/${activity.id}`}
                                        style={{
                                            display: "block",
                                            textDecoration: "none",
                                            color: "inherit"
                                        }}
                                    >
                                        {completedIds.includes(activity.id)
                                            ? "✅"
                                            : "⬜"}

                                        {" "}

                                        {activity.title}
                                    </Link>
                                </li>

                            ))}
                        </ul>

                    </div>

                );

            })}

        </div>

    );

}